import { socialDistance } from '../batchFetchers';
import { cardPartCss, chipsRowCss } from '../surface';

import type { ArmSpec } from '../armRegistry';
import type { SocialDistance } from '../batchFetchers';

const FLAG = 'socialproof';
// Two queries per work id server-side, each with the viewer's whole followee
// list in an IN clause and no timeout guard: the arm asks about the head of the
// first render only, and never about a scroll batch.
const MAX_WORKS_QUERIED = 5;
const CHIP =
  'background: #0954d3; border-radius: 100px; padding: 2px 8px; color: #fff;';

// Only followedByViewer may be spoken: bookmarkerCount sums first- and
// second-degree connections, so it is never "people you follow".
function signal(distance: SocialDistance | undefined): string | null {
  if (distance == null || distance.followedByViewer < 1) return null;

  const { followedByViewer, atLeast } = distance;
  if (atLeast) return `${followedByViewer}+ people you follow saved this paper`;

  return followedByViewer === 1
    ? '1 person you follow saved this paper'
    : `${followedByViewer} people you follow saved this paper`;
}

export const socialProofOnCards: ArmSpec = {
  onReady: async (ctx) => {
    const cards = ctx.cards().slice(0, MAX_WORKS_QUERIED);
    const distances = await socialDistance(cards.map((card) => card.workId));

    const signalled = cards.flatMap((card) => {
      const line = signal(distances.get(card.workId));

      return line == null ? [] : [{ card, line }];
    });
    if (signalled.length === 0) return;

    ctx.injectStyles(
      chipsRowCss(ctx.scope, { lineHeight: '1.4' }) +
        cardPartCss('chips', ctx.scope, 'font-size: 13px;') +
        cardPartCss('chip', ctx.scope, CHIP),
    );

    signalled.forEach(({ card, line }) => {
      card.setFlag(FLAG);
      card.addChip(line);
    });
  },
};
